module.exports = __webpack_public_path__ + "img/4.271d2705.png";